<template>
  <div>
    <skeleton header-color="bg-white" text-color="text-gray-800">
      <template slot="logo">
        <img src="/img/logo.png" alt class="h-8" />
      </template>
      <template slot="userDropdownTitle">{{ $page.auth.user.name }}</template>
      <template v-slot:userDropdownContent="{ toggleUserDropdown }">
        <button
          v-if="$page.auth.user"
          @click.prevent="
                        openModal($refs.selectLanguage)
                        toggleUserDropdown()
                    "
          class="focus:outline-none text-left w-full block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
        >
          <i class="fas fa-globe fa-fw"></i>
          <span class="inline">
            <span v-if="$page.auth.current_language">
              {{
              $page.available_languages[
              $page.auth.current_language
              ]
              }}
            </span>
            <span v-else>Select language</span>
          </span>
        </button>
        <inertia-link
          href="/admin/logout"
          method="post"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
        >
          <i class="fas fa-sign-out-alt fa-fw"></i>
          Sign out
        </inertia-link>
      </template>
      <template slot="navigation">
        <navigation-item
          :to="route('home')"
          title="Home"
          icon="fa-home"
          class="rounded-md"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('users.index')"
          title="Frontend Users"
          icon="fa-user"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('menus.index')"
          title="Menus"
          icon="fa-sitemap"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('pages.index')"
          title="Pages"
          icon="fa-browser"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('news.index')"
          title="News"
          icon="fa-newspaper"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('events.index')"
          title="Events"
          icon="fa-calendar"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('applications.index')"
          title="Applications"
          icon="fa-check"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('words.index')"
          title="Words"
          icon="fa-language"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
        <navigation-item
          :to="route('standings.index')"
          title="Standings Import"
          icon="fa-trophy"
          class="rounded-md mt-1"
          @click.native="$store.commit('startLoading')"
        />
      </template>
      <template>
        <div
          class="fixed h-screen flex justify-center items-center top-0 left-0 z-50 w-full lg:left-64 lg:w-full-64"
          v-if="$store.state.isLoading"
        >
          <div class="absolute w-full h-full bg-white opacity-75"></div>
          <loading-spinner></loading-spinner>
        </div>
        <slot />
      </template>
    </skeleton>
    <selectLanguage ref="selectLanguage" />
    <slot name="modal"></slot>
    <portal-target name="modal" multiple></portal-target>
  </div>
</template>

<script>
import selectLanguage from "./SelectLanguage";

export default {
  components: {
    selectLanguage
  },
  props: {
    title: String
  },
  data() {
    return {
      windowWidth: 0,
      baseTitle: "2nrace"
    };
  },
  watch: {
    windowWidth(newWidth) {
      if (newWidth > 1024) {
        this.$store.commit("openNavigation");
      } else {
        this.$store.commit("closeNavigation");
      }
    },
    "$page.flash": {
      handler() {
        if (this.$page.flash.success) {
          this.$toast.open({
            message: this.$page.flash.success,
            type: "success"
          });
        } else if (this.$page.flash.error) {
          this.$toast.open({
            message: this.$page.flash.error,
            type: "error"
          });
        }
      },
      deep: true,
      immediate: true
    },
    title: {
      immediate: true,
      handler(title) {
        document.title = this.baseTitle + " - " + title;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
};
</script>

<style lang="scss" scoped></style>
